import { ClientError, ErrorHandlerType, RejectedRequestHandler } from 'services/api/ApiClientService/types';

// Intercepts and handles a rejected request.
const onRejectedRequest = ({ errorHandler }: { errorHandler: ErrorHandlerType }): RejectedRequestHandler => {
    return (error: ClientError) => {
        errorHandler(error);

        return Promise.reject(error);
    };
};

export default onRejectedRequest;
